import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import 'react-quill/dist/quill.snow.css';
import {Tabs, Tab} from 'material-ui/Tabs';
import ControllButtons from '../components/ControllButtons';
import InputWithEditor from '../components/InputWithEditor';
import Video from '../components/Video';
import Podcast from '../components/PodcastInputs';
import Quiz from '../components/Quiz';
import Questions from '../components/Questions';
import BaseInformation from '../components/BaseInformation';
import {DETAILS, VIDEO, PODCAST, QUIZ} from 'constants/topicTabs';
import {inject, observer} from 'mobx-react';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {TOPIC_CONSTRAINS} from 'constants/adminPupups';

const TOPICS_REQUEST = '/api/v1/tutorials/';
const QUESTIONS_ANSWERS = '/api/v1/results/set_result';
const GET_EXAM_PREP_QUIZ = '/api/v1/cpd_quizzes';

const EMPTY_CPD_QUIZES = [
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  }
];

const TAB_ACTIVE_STYLES = {
  padding: '10px 20px',
  borderRadius: '16px',
  backgroundColor: '#467093',
  fontWeight: '700',
  color: '#FFFFFF',
  fontSize: '16px',
  textAlign: 'center',
  textDecoration: 'none',
  outline: 'none 0',
  border: '1px solid #467093',
  textTransform: 'none',
  marginRight: '16px',
  maxHeight: '42px'
};
const TAB_STYLES = {
  padding: '10px 20px',
  borderRadius: '16px',
  backgroundColor: '#FAFCFE',
  fontWeight: '700',
  color: '#2B3538',
  fontSize: '16px',
  textAlign: 'center',
  textDecoration: 'none',
  outline: 'none 0',
  border: '1px solid #DAE6F3',
  textTransform: 'none',
  margin: '0 8px',
  maxHeight: '42px'
};

@withRouter
@inject('userStore')
@inject('topicsStore')
@inject('alertStore')
@inject('examPrepHeaderStore')
@observer
class Topic extends Component {
  state = {
    selectedTab: '',
    confirmationModalOpen: false,
    topic: null,
    selectedQuiz: 0,
    quizResult: null,
    answers: [],
    totalPages: 1,
  };

  extractContent = description => {
    const span = document.createElement('span');
    span.innerHTML = description;
    return span.textContent || span.innerText;
  }

  componentWillMount() {
    const {topicsStore, match, examPrepHeaderStore: {setTopic}, userStore} = this.props;
    const id = match.params.id;
    const isAdmin = userStore.isAdmin();

    if(id) {
      new HttpClient().get(`${TOPICS_REQUEST}${id}`).then(data => {
        const topic = data.body.data.tutorial;
        const topicWithVideo = {
          ...topic,
          tutorial_videos_attributes: topic.videos,
          podcasts_attributes: topic.podcasts
        }
        let selectedTab = PODCAST;
        selectedTab = topicWithVideo.podcasts_attributes.length === 0 && topicWithVideo.tutorial_videos_attributes.length > 0 ? VIDEO : selectedTab;
        selectedTab = topicWithVideo.podcasts_attributes.length === 0 && topicWithVideo.tutorial_videos_attributes.length === 0 ? DETAILS : selectedTab;
        const withDescription = !!this.extractContent(topic.description);

        if (topic.tutorial_type !== 'regular') {
          setTopic(topic);
        }

        if (isAdmin && topic.tutorial_type === "pharmacist") {
            const topicWithSortedQuizz = {
              ...topicWithVideo,
              withDescription,
              // spd_quizzes: sortedQuizz
            };
            this.setState({
              topic: topicWithSortedQuizz,
              selectedTab,
              // answers: [{[topicWithSortedQuizz.spd_quizzes[0].id]: []}],
              // totalPages: body.total_pages,
            });
            topicsStore.setTopic(topicWithSortedQuizz);
        } else {
          const spd_quizzes = topic.spd_quizzes;
          let sortedQuizz = (spd_quizzes || []).length > 0 ? _.sortBy(spd_quizzes, 'id') : EMPTY_CPD_QUIZES;
            sortedQuizz = sortedQuizz.map(quiz => {
              const quizOptions = quiz.options ? quiz.options : [];
              const options = quizOptions.map(option => JSON.parse((option || '').replaceAll('=>', ':')));

              return {
                ...quiz,
                options
              };
            });
          const topicWithSortedQuizz = {
            ...topicWithVideo,
            withDescription,
            spd_quizzes: sortedQuizz
          };
          this.setState({
            topic: topicWithSortedQuizz,
            selectedTab,
            answers: [{[topicWithSortedQuizz.spd_quizzes[0].id]: []}]
          });
          topicsStore.setTopic(topicWithSortedQuizz);
        }

      }).catch( (e) => {
        if(e.status === 403) {
          this.props.history.push('/settings/payments');
        }
      });
    }
  }

  componentWillUnmount() {
    this.props.topicsStore.initNewTopic();
  }

  handleChange = selectedTab => {
    this.setState({selectedTab});
  };

  handleChangeTitle = e => {
    const title = e.target.value;
    this.setState({
      ...this.state.topic,
      title
    });
  }

  handleDescription = description => {
    this.setState({
      ...this.state.topic,
      description
    });
  }

  saveTopic = () => {
    const {topicsStore} = this.props;
    let topic = _.assign({}, topicsStore.topic);
    let errors = this.validationProcess(topic);

    this.setState({errors});

    this.props.topicsStore.setError(errors);
    if (errors) {
      return;
    }
    let formData = new FormData();

    _.mapKeys(topic, (value, key) => {
      if (key === 'spd_quizzes' && topic[key] && topic[key][0].question) {
        value.forEach(el => {
          if (el.id) {
            formData.append('spd_quizzes_attributes[]id', el.id)
          }
          formData.append('spd_quizzes_attributes[]question', el.question)
          formData.append('spd_quizzes_attributes[]key_learnings', el.key_learnings)
          formData.append('spd_quizzes_attributes[]explanation', el.explanation)
          formData.append('spd_quizzes_attributes[]quiz_type', 1);
          el.options.forEach(option => {
            _.mapKeys(option, (valueQuestion, keyQuestion) => {
              formData.append('spd_quizzes_attributes[]options[]' + keyQuestion, valueQuestion)
            })
          });
        });
      }
      else if (key === 'questions') {
        value.forEach(el => {
          _.mapKeys(el, (valueQuestion, keyQuestion) => {
            formData.append('questions_attributes[]' + keyQuestion, valueQuestion)
          })
        })
      } else if (key === 'tutorial_videos_attributes' && topic[key][0]) {
        value.forEach((video) => {
          _.mapKeys(video, (value, key) => {
            formData.append('tutorial_videos_attributes[]' + key, value);
          })
        })
      } else if(key === 'podcasts_attributes' && topic[key][0]) {
        value.forEach((podcast) => {
          _.mapKeys(podcast, (value, key) => {
            formData.append('podcasts_attributes[]' + key, value);
          })
        })
      } else if(key !== 'podcasts_attributes' && key !== 'tutorial_videos_attributes') {
        formData.append(key, value);
      }
    });

    if (!topic.id)
      new HttpClient().multipart(TOPICS_REQUEST, formData, 'POST').then(data => {
        topicsStore.saveTopic(data.body.data.tutorial);
        topicsStore.initNewTopic();
        this.props.alertStore.success('You successfully created tutorial');
        this.props.history.push('/');
        
      }).catch((e) => {
        this.props.alertStore.success('Something went wrong');
        this.handleUnsuportableEntity(e)
      });
    else {
      new HttpClient().multipart(TOPICS_REQUEST + topic.id, formData, 'PUT').then(data => {
        topicsStore.updateTopic(data.body.data.tutorial);
        topicsStore.initNewTopic();
        this.props.alertStore.success('You successfully updated tutorial');
        this.props.history.push('/');
      }).catch((e) => {
        this.props.alertStore.success('Something went wrong');
        this.handleUnsuportableEntity(e)
      })
    }
  }

  handleValidationError = errors => {
    let newErrors = {};
    let maxEndTime;
    if (errors['questions.time']) {
      maxEndTime = errors['questions.time'][0];
    }
    if (errors.title) {
      newErrors = _.assign(newErrors, { title: 'Has already been taken' });
    }

    if (errors.friendly_id_url) {
      newErrors = _.assign(newErrors, { friendly_id_url: 'Has already been taken' });
    }
    if (errors.video_url) {
      newErrors = _.assign(newErrors, { video_url: 'Video not found' });
    }
    let questions = this.validateMaxEndTime(maxEndTime);
    if (!_.isEmpty(questions))
      newErrors = _.assign(newErrors, { questions: questions });

    this.props.topicsStore.setError(newErrors);
  };

  validateMaxEndTime = (time) => {
    let questions = [];
    let topic = _.assign({}, this.props.topicsStore.topic);
    topic.questions.forEach(el => {
      let endTime = parseInt(el.end_time);
      if (endTime > time)
        questions.push({ end_time: [`Maximum is ${this.getPrettyTime(time)}`], stubKey: el.stubKey })
    });
    return questions;
  };

  getPrettyTime = seconds => {
    let hours = parseInt(seconds / (60 * 60));
    let minutes = parseInt(((seconds - hours * 60 * 60) / 60));
    seconds = seconds - minutes * 60 - hours * 60 * 60;
    return `${hours} : ${minutes} : ${seconds}`
  };

  handleUnsuportableEntity = e => {
    if (e.status === 422)
      this.handleValidationError(e.body.data.errors);
    if (e.status === 400)
      this.props.topicsStore.setError({ video_url: 'Video url invalid' });
  };

  validationProcess = tutorial => {
    let errors = validate(tutorial, TOPIC_CONSTRAINS(tutorial), { fullMessages: false });

    return errors
  };

  openDeleteConfirmModal = () => {
    this.setState({ confirmationModalOpen: true });
  }

  closeDeleteConfirmModal = () => {
    this.setState({ confirmationModalOpen: false });
  }

  deleteCourse = () => {
    const { topic } = this.props.topicsStore;
    new HttpClient().delete(`${TOPICS_REQUEST}${topic.id}`).then((res) => {
      if(res.status === 200) {
        this.closeDeleteConfirmModal();
        this.props.topicsStore.deleteTopic(topic.id);
        this.props.history.push('/');
        this.props.alertStore.success('You successfully deleted tutorial');
      }
    }).catch(() => {
      this.closeDeleteConfirmModal();
      this.props.alertStore.success('Something went wrong');
    });
  }

  selectQuiz = selectedQuiz => {
    this.setState({selectedQuiz, quizResult: null});
  }

  onQuestionAnswerEdit = (e, index) => {
    const {id, value} = e.target || {};
    const { answers, selectedQuiz } = this.state;
    const newAnswers = [...answers];
    const newAnswerObject = newAnswers[selectedQuiz];
    const options = [...newAnswerObject[id]];
    const answerIndex = options.map(option => Object.keys(option)[0]).indexOf(`answer_${index}`);

    if (answerIndex !== -1) {
      options.splice(answerIndex, 1);
    } else {
      options.push({[`answer_${index}`]: value});
    }

    newAnswerObject[id] = options;

    this.setState({
      answers: newAnswers
    });
  }

  onAnswerEdit = (e, value) => {
    const { answers, selectedQuiz } = this.state;
    const newAnswers = [...answers];
    const newAnswerObject = newAnswers[selectedQuiz];
    newAnswerObject[e.target.id] = value;

    this.setState({
      answers: newAnswers
    });
  }

  onNextQuestion = () => {
    const { topic, selectedQuiz, answers } = this.state;
    const newAnswers = [...answers];

    newAnswers.push({ [topic.spd_quizzes[selectedQuiz + 1].id]: '' });

    this.setState({selectedQuiz: selectedQuiz + 1, answers: newAnswers});
  }

  nextQuestions = (page) => {
    const { topic } = this.state;
    const { topicsStore } = this.props;

    new HttpClient().get(`${GET_EXAM_PREP_QUIZ}?page=${page.selected + 1}&per_page=10`).then(({body}) => {
      const spd_quizzes = body.data.spd_quizzes;

      let sortedQuizz = (spd_quizzes || []).length > 0 ? _.sortBy(spd_quizzes, 'id') : EMPTY_CPD_QUIZES;
        sortedQuizz = sortedQuizz.map(quiz => {
          const quizOptions = quiz.options ? quiz.options : [];
          const options = quizOptions.map(option => JSON.parse((option || '').replaceAll('=>', ':')));

          return {
            ...quiz,
            options
          };
        });
      const topicWithSortedQuizz = {
        ...topic,
        spd_quizzes: sortedQuizz
      };
      this.setState({
        topic: topicWithSortedQuizz,
        answers: [{[topicWithSortedQuizz.spd_quizzes[0].id]: []}],
        totalPages: body.total_pages,
      });
      topicsStore.setTopic(topicWithSortedQuizz);
      window.scrollTo({top: 0});
    });
  };

  submitAnswers = event => {
    event.preventDefault();
    const { topic, answers } = this.state;
    const quizCorrects = topic.spd_quizzes.map(quiz => quiz.options.filter(option => option.correct === 'true').length)
    const allAnswers = answers.map(id => id[Object.keys(id)[0]]).map((option) => option.map((answer) => answer[Object.keys(answer)[0]]));
    const correctAnswersLength = allAnswers.map(answer => answer.filter(correct => answer.indexOf('false') === -1 && correct === 'true').length);
    const answersCount = correctAnswersLength.filter((correctLength, index) => quizCorrects[index] === correctLength).length;

    new HttpClient().post(QUESTIONS_ANSWERS, { answers_count: answersCount, id: topic.id })
    .then(response => {
      if(response.body.completed === 'you completed')
        this.setState({quizResult: response.body.answers_count || answersCount, selectedQuiz: 0, answers: [{}]});
    })
    .catch(e => {
      this.setState({quizResult: e.body.answers_count || answersCount, selectedQuiz: 0, answers: [{}]});
    });
  }

  render() {
    const {selectedTab, confirmationModalOpen, answers, selectedQuiz, quizResult, totalPages} = this.state;
    const {topicsStore, userStore} = this.props;
    const customContentStyle = {
      height: '100%',
      maxHeight: 'none'
    };

    return (
      <section className="section topic-edit" style={{overflow: 'scroll'}}>
        <div className="container-fluid">
          <Dialog
            className="modal-wrapper category-handle"
            title='Are you sure you want to delete this topic?'
            modal={true}
            open={confirmationModalOpen}
            customContentStyle={customContentStyle}
            bodyClassName="modal-content"
            repositionOnUpdate={true}
            autoDetectWindowHeight={true}
            autoScrollBodyContent={false}>
            <div className="button-set">
              <button className="btn gray small transparanted cancel-btn" type="reset"
                onClick={this.closeDeleteConfirmModal}>No
                </button>
              <button className="btn gray small transparanted apply-btn" type="submit"
                onClick={this.deleteCourse}>Yes
                </button>
            </div>
          </Dialog>
          { userStore.isAdmin() ?
            <ControllButtons
              saveTopic={this.saveTopic}
              topic={topicsStore.topic}
              openDeleteConfirmModal={this.openDeleteConfirmModal}
            /> :
            <div className="tab-container">
              <div className="row justify-content-center">
                <h3 className='container-header' style={{textTransform: 'capitalize'}}>{topicsStore.topic.title}</h3>
              </div>
            </div>
          }
          <div className="row">
            <div className="container justify-content-center">
              <div className="edit-container">
                
                <Tabs
                  value={selectedTab}
                  onChange={this.handleChange}
                  inkBarStyle={{background: 'transparent'}}
                  className='course-tabs-component'
                >
                  {userStore.isAdmin() || topicsStore.topic.podcasts_attributes.length > 0 ?
                    <Tab
                      label="Podcast"
                      value={PODCAST}
                      buttonStyle={selectedTab === PODCAST ? TAB_ACTIVE_STYLES : TAB_STYLES}
                      className={selectedTab === PODCAST ? 'btn-new-main' : 'btn-new-white'}
                    >
                      <Podcast topic={topicsStore.topic} />
                    </Tab> : null
                  }
                  { userStore.isAdmin() || topicsStore.topic.tutorial_videos_attributes.length > 0 ?
                    <Tab
                      label="Video"
                      buttonStyle={selectedTab === VIDEO ? TAB_ACTIVE_STYLES : TAB_STYLES}
                      className={selectedTab === VIDEO ? 'btn-new-main' : 'btn-new-white'}
                      value={VIDEO}
                    >
                      <Video topic={topicsStore.topic} />
                    </Tab> : null
                  }
                  {userStore.isAdmin() && (
                    <Tab
                      label="Details"
                      buttonStyle={selectedTab === DETAILS ? TAB_ACTIVE_STYLES : TAB_STYLES}
                      className={selectedTab === DETAILS ? 'btn-new-main' : 'btn-new-white'}
                      value={DETAILS}
                    >
                      <InputWithEditor />
                    </Tab>
                  )}
                  {(!userStore.isAdmin() && topicsStore.topic.withDescription) && (
                    <Tab
                      label="Details"
                      buttonStyle={selectedTab === DETAILS ? TAB_ACTIVE_STYLES : TAB_STYLES}
                      className={selectedTab === DETAILS ? 'btn-new-main' : 'btn-new-white'}
                      value={DETAILS}
                    >
                      <BaseInformation />
                    </Tab>
                  )}
                  { (userStore.isAdmin() || (topicsStore.topic.id !== 1 && topicsStore.topic.spd_quizzes[0].question && topicsStore.topic.is_visible_quize)) ?
                    <Tab
                      label="Quiz"
                      buttonStyle={selectedTab === QUIZ ? TAB_ACTIVE_STYLES : TAB_STYLES}
                      className={selectedTab === QUIZ ? 'btn-new-main' : 'btn-new-white'}
                      value={QUIZ}
                    >
                      { userStore.isAdmin() ?
                        <Quiz nextQuestions={this.nextQuestions} totalPages={totalPages} /> :
                        <Questions
                          id={topicsStore.topic.id}
                          completed={topicsStore.topic.completed}
                          answer={answers[selectedQuiz]}
                          selectedQuiz={selectedQuiz}
                          quiz={topicsStore.topic.spd_quizzes[selectedQuiz]}
                          onAnswerEdit={this.onAnswerEdit}
                          onNextQuestion={this.onNextQuestion}
                          submitAnswers={this.submitAnswers}
                          quizResult={quizResult}
                          // disabled={answers[selectedQuiz][topicsStore.topic.spd_quizzes[selectedQuiz].id]}
                          selectQuiz={this.selectQuiz}
                          onQuestionAnswerEdit={this.onQuestionAnswerEdit}
                          answers={answers}
                        />
                      }
                    </Tab> : null
                  }
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Topic;



// WEBPACK FOOTER //
// ./src/modules/topic/containers/Topic.js